// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"543":"gallery","962":"home"}[chunkId] + "." + {"543":"199fc6e6","962":"01e937c0"}[chunkId] + ".css";
};